import { SurveyReferenceQuestion } from './SurveyReferenceQuestion';
import { SurveyDependentReferenceQuestionProps } from './referenceTypes';

export const SurveyDependentReferenceQuestion = ({
  question,
  answer,
  readonly,
  value,
  hasSubQuestions,
  survey,
  componentId,
  parentQuestionId,
  fields,
  currentLocale,
  i18nLocale,
  hasAttemptedSubmission,
  hasAutocompleteFeature,
  hasReferenceSuggestionsFeature,
  hasEditableReferencesInQuestionsFeature,
  noAccessReferences,
  isEmbedded,
  hideReadOnlyLabel,
  QuestionContentWrapper,
  highlightUnansweredPriorityQuestions,
  addNestedDependentAnswer,
  removeNestedDependentAnswer,
  setAnswer,
  updateReferenceComponent,
  getDuplicate,
  getExistingComponentByName,
  setNestedAnswer,
  generateComponentDescription,
  trackDescriptionGenerated,
  trackDescriptionGeneratedFailed,
  trackCreatedReferenceFromQuestion,
  getAISuggestions,
  fetchComponentOptionsWithQuery,
  userOptions,
}: SurveyDependentReferenceQuestionProps) => {
  return (
    <SurveyReferenceQuestion
      userOptions={userOptions}
      question={question}
      answer={answer}
      fields={fields}
      value={value}
      survey={survey}
      hasSubQuestions={hasSubQuestions}
      componentId={componentId}
      readonly={readonly}
      currentLocale={currentLocale}
      i18nLocale={i18nLocale}
      hasAttemptedSubmission={hasAttemptedSubmission}
      hasAutocompleteFeature={hasAutocompleteFeature}
      hasReferenceSuggestionsFeature={hasReferenceSuggestionsFeature}
      hasEditableReferencesInQuestionsFeature={
        hasEditableReferencesInQuestionsFeature
      }
      noAccessReferences={noAccessReferences}
      isEmbedded={isEmbedded}
      hideReadOnlyLabel={hideReadOnlyLabel}
      QuestionContentWrapper={QuestionContentWrapper}
      highlightUnansweredPriorityQuestions={
        highlightUnansweredPriorityQuestions
      }
      addNestedAnswer={nestedAnswer => {
        addNestedDependentAnswer({ ...nestedAnswer, parentQuestionId });
      }}
      setNestedAnswer={setNestedAnswer}
      removeNestedAnswer={nestedAnswer => {
        removeNestedDependentAnswer({ ...nestedAnswer, parentQuestionId });
      }}
      setAnswer={setAnswer}
      updateReferenceComponent={updateReferenceComponent}
      getDuplicate={getDuplicate}
      getExistingComponentByName={getExistingComponentByName}
      generateComponentDescription={generateComponentDescription}
      trackDescriptionGenerated={trackDescriptionGenerated}
      trackDescriptionGeneratedFailed={trackDescriptionGeneratedFailed}
      trackCreatedReferenceFromQuestion={trackCreatedReferenceFromQuestion}
      getAISuggestions={getAISuggestions}
      fetchComponentOptionsWithQuery={fetchComponentOptionsWithQuery}
    />
  );
};
